<template>
  <div id="cup_teamDetail_matchRecord" v-show="currThemeObj">
    <schedule_group_matchList
      v-for="item in matchList"
      :currCid="currCid"
      :currSid="currSid"
      :key="item.icon"
      :currThemeObj="currThemeObj"
      :data="item"
      :pbPx="matchItemPbpx"
      :isShowLabelIcon="isShowLabelIcon"
      :filterCondition="scheduleMatchList_matchMode.filterCondition"
    >
      <template v-slot:matchList>
        <schedule_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="item.list"
          :detailPathName="`scheduleDetailIndex_${currThemeObj.moduleRouteNameEn}`"
          :chooseState="'default'"
          :matchModeObj="scheduleMatchList_matchMode"
        />
      </template>
    </schedule_group_matchList>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import schedule_group_matchList from '@components/platfromBase/compreSportsMeet/schedule_group_matchList.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import { https_cup_teamMatchRecord } from '@api/platfrom_football_api'
export default {
  name: 'cup_teamDetail_matchRecord',
  mixins: [cup_base_data_mixin],
  components: { schedule_group_matchList, schedule_match_list },
  data() {
    return {
      isShowLabelIcon: false,
      matchList: [],
      matchItemPbpx: 0,
      scheduleMatchList_matchMode: {
        mode: 'FIFAWorldCup',
        type: 'matchDate',
        filterCondition: 'team_-1',
      },
    }
  },
  created() {
    console.debug('route:', this.$route)
    const query = this.$route.query
    this.init(query)
  },
  methods: {
    async init(params) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initPbPx()
      await this.getTeamMatchRecord(params)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    initPbPx() {
      this.matchItemPbpx = Math.ceil(2.78 * this.vw2px)
      console.debug('this.matchItemPbpx:', this.matchItemPbpx)
    },
    computedMatchList(arr, type, select) {
      // 切换展示状态，组装不同的赛程列表数据
      console.debug(select)
      let labelArr = []
      if (!type) {
        type = 'matchDate'
      }
      // 小组赛阶段对应的Id
      let groupKey = 'GS'
      // 小组赛中A|B取这个字段
      let dynamicSeriesKeyArr = ['seriesCode', 'seriesName']
      // 阶段取这个字段
      let dynamicStageKeyArr = ['stageId', 'stageName']
      arr.forEach((item) => {
        if (labelArr.length == 0 || !labelArr.includes(item[type])) {
          labelArr.push(item[type])
        }
      })
      console.debug('labelArr:', labelArr)
      return labelArr.map((typeItem) => {
        let obj = {
          label: '',
          key: typeItem,
          list: [],
        }
        arr.forEach((item) => {
          let week = '星期' + this.getWeekCN(item.matchDate)
          let dateArr = item.matchDate.split('-')
          let weekCN = ''
          if (dateArr.length == 3) {
            weekCN = `${dateArr[1]}月${dateArr[2]}日 ${week}`
          }

          if (typeItem == item[type]) {
            if (!obj.label) {
              if (type == 'matchDate') {
                // 按日期展示
                obj.label = weekCN
              } else {
                // 按小组展示
                obj.label = `${typeItem}组`
              }
            }
            item.weekCN = weekCN

            if (item[dynamicStageKeyArr[0]] === groupKey) {
              // 小组赛
              item.stageCodeWeb = item[dynamicSeriesKeyArr[0]]
              item.stageNameWeb = item[dynamicSeriesKeyArr[1]]
            } else {
              // 非小组赛
              item.stageCodeWeb = item[dynamicStageKeyArr[0]]
              item.stageNameWeb = item[dynamicStageKeyArr[1]]
            }
            obj.list.push(item)
          }
        })
        // console.debug('obj:', obj)

        return obj
      })
    },
    async getTeamMatchRecord(query) {
      await https_cup_teamMatchRecord(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.matchList = this.computedMatchList(
              res.data ? res.data : [],
              this.scheduleMatchList_matchMode.type,
              this.scheduleMatchList_matchMode.filterCondition
            )
            // this.matchList = res.data ? res.data : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_teamDetail_matchRecord {
  padding: 2.778vw 0;
}
</style>
